import { takeEvery, put } from 'redux-saga/effects';
import { Types, Actions } from './reducers';

function* initThemeSaga() {
    const savedTheme = localStorage.getItem('theme') || 'orange';
    yield put(Actions.setTheme(savedTheme));
}

export default function* themeSaga() {
    yield takeEvery(Types.INIT_THEME, initThemeSaga);
} 